import styled from 'styled-components';

import MaskImage from 'assets/img/hexa-mask-2.png';
import MaskStar from 'assets/icons/rating-stars-icon.svg';

interface IRatingStarsProps {
  fill: 'full' | 'half' | 'empty';
}

export const Container = styled.section`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  inset: 0;
  z-index: 9999;

  background-color: rgb(211 228 255 /70%);
  backdrop-filter: blur(4px);

  animation: entering 0.5s forwards;

  &.modal-agenda-details--hide{
    animation: exiting 0.5s forwards;
  }
`

export const ModalContainer = styled.article`
  width: 95%;
  max-width: 380.85px;
  height: 673.45px;
  max-height: 99vh;
  padding: 42.2px 0 55.4px;

  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  border-radius: 32px;
  background: rgb(0,120,215);
  background: linear-gradient(40deg, rgba(0,120,215,1) 0%, rgba(102,182,231,1) 65%, rgba(179,229,243,1) 100%);
  box-shadow: 0 3px 6px rgba(0,0,0,0.16)
`

export const ModalCloseButton = styled.button`
width: fit-content;
height: fit-content;

position: absolute;
top: 42.2px;
right: 29.9px;

border: 0;
font-size: 22px;
font-weight: bold;
color: var(--blue02);
background-color: transparent;
cursor: pointer;

transition: filter 0.3s;

&:hover {
  filter: brightness(1.1);
}
`
export const ProviderContainer = styled.div`
  width: 85%;
  max-width: 253.2px;
  height: fit-content;
  margin: 0 auto;

  position: relative;
`

export const UserImage = styled.img`
  width: 65%;
  height: auto;
  aspect-ratio: 1 / 1;

  position: relative;
  z-index: 2;

  border-radius: 50%;
  object-fit: cover;
  outline: 5px solid var(--blue00);
`

export const ProviderServiceIcon = styled.div`
  width: 50%;
  height: auto;
  aspect-ratio: 107.83 / 123.87;

  position: absolute;
  top: 50%;
  right: 0;
  z-index: 1;

  background-color: var(--blue00);

  mask-image: url(${MaskImage});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    filter: brightness(0) invert(1);
    -webkit-filter: brightness(0) invert(1);
  }
`

export const ServiceNumber = styled.p`
  width: 85%;
  height: fit-content;
  margin: 0 auto;

  font-size: 0.875rem;
  font-weight: bold;
  color: #fff;
`

export const ServiceName = styled.p`
  width: 85%;
  height: fit-content;
  margin: 0 auto;
  margin-top: 1.125rem;

  font-size: 0.875rem;
  font-weight: bold;
  color: #fff;
`

export const ProviderName = styled.h1`
  width: 85%;
  height: fit-content;
  margin: 0 auto;

  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
`

export const StarsContainer = styled.div`
  width: 85%;
  height: fit-content;
  margin: 0 auto;

  display: flex;
  justify-content: flex-start;
  align-items: center;
`

export const ServiceDate = styled.h1`
  width: 85%;
  height: fit-content;
  margin: 0 auto;

  font-size: 1.0625rem;
  color: #fff;
`
export const MapButton = styled.button`
  width: 85%;
  max-width: 114.54px;
  height: 37.27px;
  margin: 0 7.5%;
  padding: 0 23.3px 0 15.9px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  border-radius: 19px;
  background-color: var(--blue00);
  color: #fff;
  font-size: 0.75rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.24);
  border: 0;
  outline: none;
  cursor: pointer;
`
export const AppointmentInfo = styled.h1`
  width: 85%;
  max-height: 2.125rem;
  margin: 0 auto;

  font-size: 1.0625rem;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const RatingStars = styled.span<IRatingStarsProps>`
  width: 17.25px;
  height: 16.45px;

  background-color: #C6F0FF;

  mask-image: url(${MaskStar});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;

  &:before{
    content: '';
    width: ${({fill}) => {
      switch(fill){
        case 'full':
          return '100%';
        case 'half':
          return '50%';
        case 'empty':
          return '0';
      }
    }};
    height: 100%;

    display: block;

    background-color: #FFDF00;
  }
`
